export default __webpack_public_path__ + "static/breakdown-3c31f9a702ac77ff093d8e74cb3b1460.png";